export * from './schedule-modal.component';


// WEBPACK FOOTER //
// ./src/app/content/shared/components/schedule-modal/index.ts